//根据list集合生成树，idname可以指id，pidname可以指pid或parentId,自己定义的
function arrayToJsonTree(treeArray, idname, pidname) {
  var r = [];
  var tmpMap = {};
  for (var i = 0, l = treeArray.length; i < l; i++) {
    tmpMap[treeArray[i][idname]] = treeArray[i];
  }
  for (i = 0, l = treeArray.length; i < l; i++) {
    var key = tmpMap[treeArray[i][pidname]];
    if (key) {
      if (!key["children"]) {
        key["children"] = [];
        key["children"].push(treeArray[i]);
      } else {
        key["children"].push(treeArray[i]);
      }
    } else {
      r.push(treeArray[i]);
    }
  }
  return r
}

function formatSeconds(value) {
  var secondTime = parseInt(value) / 1000;// 秒
  var minuteTime = 0;// 分
  var hourTime = 0;// 小时
  if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = "" + parseInt(secondTime) + "秒";

  if (minuteTime > 0) {
    result = "" + parseInt(minuteTime) + "分" + result;
  }
  if (hourTime > 0) {
    result = "" + parseInt(hourTime) + "小时" + result;
  }
  return result;
}


function getTimeRange(rangeDate) {
  let rangeType = rangeDate.dateRange
  var fmt = "YYYY-MM-DD HH:mm";
  var now = new Date();
  var end = new Date();
  if (!rangeType) {

  }
  switch (rangeType) {
    case "TD": {
      break;
    }
    case "YD": {
      //昨日
      now.setDate(now.getDate() - 1);
      end.setDate(end.getDate() - 1);
      break;
    }
    case "TW": {
      //本周
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      if (nowDayOfWeek == 0) {
        nowDayOfWeek = 6;	//周日
      } else {
        nowDayOfWeek = nowDayOfWeek - 1;
      }
      now.setDate(now.getDate() - nowDayOfWeek);
      end.setDate(now.getDate() + 6);
      break;
    }
    case "LW": {
      //上周
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      if (nowDayOfWeek == 0) {
        nowDayOfWeek = 6;	//周日
      } else {
        nowDayOfWeek = nowDayOfWeek - 1;
      }

      now.setDate(now.getDate() - nowDayOfWeek - 7);
      end.setDate(now.getDate() + 6);
      break;
    }
    case "TM": {
      //本月
      now.setDate(1);
      var nextMonth = end.getMonth() + 1;
      var nextMonthFirstDay = new Date(end.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      end = new Date(nextMonthFirstDay - oneDay);
      break
    }
    case "LM": {
      //上月
      var nextMonth = now.getMonth() - 1;
      now.setMonth(nextMonth);
      now.setDate(1);
      nextMonth = nextMonth + 1;
      var nextMonthFirstDay = new Date(end.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      end = new Date(nextMonthFirstDay - oneDay);
      break
    }
    case "CUSTOM": {
      now = new Date(rangeDate.startDate)
      end = new Date(rangeDate.endDate)
      break
    }
    default: {
      now = null
      end = null
    }
  }
  if(now!=null&&end!=null){
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
  }
  try {
    rangeDate.startDate = now;
    rangeDate.endDate = end;
  } catch (e) {
  }
  return {
    "start": now,
    "end": end
  }
}


export default {
  arrayToJsonTree,
  formatSeconds,
  getTimeRange
}



// WEBPACK FOOTER //
// ./src/util/tools.js